import { request } from "@/lib/request";

export interface OperatorItem {
  id: number
  oem_id: string
  level: string
  level_label: string
  region_id: string
  user_id: string
  region_name: string
  province_name: string
  city_name: string
  district_name: string
  operator: {
    id: number
    user_id: string
    username: string
    nickname: string
    cash_balance: number
  } | null
}

export interface RegionOption {
  value: string
  label: string
}

export async function getOperatorList() {
  return request<OperatorItem[]>('/api/oem_admin/operators', { method: 'GET' })
}

export async function assignOperator(data: {
  user_id: string
  level: string
  region_id: string
}) {
  return request('/api/oem_admin/operators', { method: 'POST', data })
}

export async function unassignOperator(id: number) {
  return request(`/api/oem_admin/operators/${id}`, { method: 'DELETE' })
}

export async function getRegionOptions(level: string, parent?: string) {
  return request<RegionOption[]>('/api/region/options', {
    method: 'GET',
    params: { level, parent: parent || '' },
  })
}
